module.exports = __webpack_public_path__ + "static/media/BackGroundHague2_compressed.477d1c3a.png";